import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { httpService } from "../../base/services/httpService.service";
import { validateConfirmationCode } from "./authSlice";
import AssessmentPhoto from "../../assets/icons/assessmentPhoto.png";
import "./style.scss";
import { ReactComponent as RegisterPhoto } from "../../assets/icons/registerPhoto.svg";
import { ReactComponent as Wave } from "../../assets/icons/wave.svg";

function ConfirmCode() {
   const { state } = useLocation();
   const [code, setCode] = useState();
   const dispatch = useDispatch();
   const navigate = useNavigate();
   const value = localStorage.getItem("userId");

   const sentCode = () => {
      let formattedUserId = value.replace(/"/g, "");

      console.log("value", formattedUserId);
      httpService.post(
         "/v2/Account/confirmEmail",
         {
            userId: formattedUserId,
            code: code
         },
         (res) => {
            // setSurveyList(res.dataResult);
            // setIsLoading(false);
            console.log("res", res);
            // Toast.success("Please fill the organization information!");
            navigate(`/auth/confirm-request`);
         },
         () => {
            // setIsLoading(false);
         }
      );
   };

   return (
      <div className="bg-form w-full" style={{ minHeight: "100vh" }}>
         <div
            className="container pt-10 d-flex align-items-center justify-content-center"
            // style={{ backgroundColor: "#fff" }}
         >
            {/* Card */}
            <div
               className="card d-flex p-10"
               style={{
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                  maxWidth: "950px",
                  borderRadius: "28px"
               }}
            >
               {/* image */}
               <div className="col-md-6">
                  <img alt="icon" src={AssessmentPhoto} />
               </div>
               <div
                  className="col-md-6"
                  // style={{
                  //    display: "flex",
                  //    flexDirection: "column",
                  //    justifyContent: "space-between"
                  // }}
               >
                  <p
                     style={{
                        fontFamily: "Nunito Sans",
                        fontSize: "20px",
                        fontWeight: "800",
                        lineHeight: "27.74px"
                     }}
                  >
                     To finish your application, please check your email for the verification code
                  </p>
                  <p
                     style={{
                        fontFamily: "Nunito Sans",
                        fontWeight: "300",
                        fontSize: "16px",
                        lineHeight: "27.74px"
                     }}
                  >
                     Enter code
                  </p>
                  <input
                     // maxLength={6}
                     onChange={(e) => setCode(e.target.value)}
                     className="code-area"
                  />
                  <div className="btn-area">
                     <button
                        onClick={() => sentCode()}
                        className="btn-outline mt-10"
                        style={{
                           borderRadius: "8px",
                           background: "#036051",
                           border: "#036051",
                           color: "white",
                           padding: "10px 25px"
                        }}
                     >
                        Send Application
                     </button>
                  </div>
               </div>
            </div>
         </div>
         <div className="footer">
            <Wave className="wave-svg" />
         </div>
      </div>
   );
}

export default ConfirmCode;
